<template>
  <!-- qrLinkに値が入れば表示 -->
  <img v-if="qrLink" class="passQR" :src="qrLink" alt="QRコード" />
</template>

<script>
export default {
  name: "PFaceOldQRLink",
  props: {
    qrLink: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss">
.passQR {
  width: 60%;
  max-width: 200px;
  margin: auto;
  margin-top: 30px;
  display: block;
}
</style>
